var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCircleNotDelivered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.6504H11V15.6504H9V13.6504ZM9 5.65039H11V11.6504H9V5.65039ZM9.99 0.650391C4.47 0.650391 0 5.13039 0 10.6504C0 16.1704 4.47 20.6504 9.99 20.6504C15.52 20.6504 20 16.1704 20 10.6504C20 5.13039 15.52 0.650391 9.99 0.650391ZM10 18.6504C5.58 18.6504 2 15.0704 2 10.6504C2 6.23039 5.58 2.65039 10 2.65039C14.42 2.65039 18 6.23039 18 10.6504C18 15.0704 14.42 18.6504 10 18.6504Z",
    fill: "#CB282E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCircleNotDelivered);
export default __webpack_public_path__ + "static/media/red-circle-not-delivered.e215117a41a0616bcf4f584e368af95a.svg";
export { ForwardRef as ReactComponent };